import { render, staticRenderFns } from "./CampaignsGridContent.vue?vue&type=template&id=541c943a"
import script from "./CampaignsGridContent.vue?vue&type=script&lang=ts"
export * from "./CampaignsGridContent.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsGridContent.vue?vue&type=style&index=0&id=541c943a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports